import React, { ReactNode } from 'react';
import { RequestDataProvider } from 'request-sender';

export const DataProviderReactContext = React.createContext<
  RequestDataProvider[] | undefined
>(undefined);

export function useDataProvidersContext() {
  return React.useContext(DataProviderReactContext);
}

export function DataProviderContext(
  props: {
    children: ReactNode,
    data: RequestDataProvider[],
  }
) {
  const parentContext = useDataProvidersContext();

  const data = [
    ...(parentContext || []),
    ...props.data,
  ]

  return (
    <DataProviderReactContext.Provider value={data}>
      {props.children}
    </DataProviderReactContext.Provider>
  )
}
